import { useCallback, useState } from 'react'

import { useApplePayAvaiable } from '@/hooks/payments/useApplePayAvailable'

import { TGetItemFn, TPlan, TSetItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { StripeWalletButtonTheme } from '@/enums/stripe'

import { PrimaryButtonWithIcon } from '@/components/buttons'

import { walletPaymentButtonMap } from '@/commonPages/paymentScreenPage/componentMappings'
import { TPaymentScreenPageOptions } from '@/commonPages/paymentScreenPage/types'
import { useSession } from '@/core/session/useSession'

export type TSelectPlanBlockWithApplePayProps = {
  selectedPlan: TPlan
  onClick: () => void
  getItem: TGetItemFn
  setItem: TSetItemFn
  buttonClassName?: string
  buttonName: string
  walletButtonTheme: StripeWalletButtonTheme
  paymentOptions: TPaymentScreenPageOptions
}

export const WalletOrPrimaryButton = ({
  selectedPlan,
  getItem,
  setItem,
  onClick,
  paymentOptions,
  buttonName,
  walletButtonTheme,
  buttonClassName,
}: TSelectPlanBlockWithApplePayProps) => {
  const { checkoutFlowVersion } = useSession()
  const [walletIsReady, setWalletIsReady] = useState<boolean>(false)
  const WalletPaymentFC = walletPaymentButtonMap[checkoutFlowVersion]

  const { appleAvailable, hasCard: appleHasCard } = useApplePayAvaiable(true, 2000)

  const onReady = useCallback((): void => {
    setWalletIsReady(true)
  }, [setWalletIsReady])

  const applePayCheckInProgress = appleAvailable == null || (appleAvailable && appleHasCard == null)
  const showApplePay = Boolean(appleAvailable && appleHasCard)

  return (
    <>
      {!applePayCheckInProgress && showApplePay && (
        <WalletPaymentFC
          planData={selectedPlan}
          getItem={getItem}
          setItem={setItem}
          pageName={PageName.selectPlan}
          config={window.config}
          stripeButtonTheme={walletButtonTheme}
          getStripeWalletButtonStyles={paymentOptions.getStripeWalletButtonStyles}
          onReady={onReady}
          successRedirectTo={paymentOptions.successRedirectTo || PageName.paymentSuccess}
          contactStateRoutesMap={paymentOptions.contactStateRoutesMap}
        />
      )}
      {(applePayCheckInProgress || !showApplePay || !walletIsReady) && (
        <PrimaryButtonWithIcon
          isLoading={applePayCheckInProgress}
          onClick={onClick}
          className={buttonClassName}
          text={buttonName}
        ></PrimaryButtonWithIcon>
      )}
    </>
  )
}
